
function withScope () {}
function captureException () {}
  
export {
  withScope,
  captureException
}